import { render } from "./SpoiledText.vue?vue&type=template&id=edc2e996&scoped=true"
import script from "./SpoiledText.vue?vue&type=script&lang=js"
export * from "./SpoiledText.vue?vue&type=script&lang=js"

import "./SpoiledText.vue?vue&type=style&index=0&id=edc2e996&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc2e996"]])

export default __exports__